import { commonKeys, routeKeys } from 'ui/data/constants/keys';
import { payrollProtectionKeys, practiceTypes } from 'ui/data/commercial/payrollprotection/constants/keys';
import { PUT_POLICY, save } from '@cogitate/ui-multi-utils';
// import { convertAddress } from '@cogitate/ui-multi-utils/dist/utilities/pages/shared/convertAddress';
// import { getModelSchema } from 'ui/utilities/helper';
import NProgress from 'nprogress';
import moment from 'moment';
import { toast } from 'react-toastify';
import { handleSubmitQuoteLanding } from 'ui/utilities/DDMHelper';
import { stripPayrollProtectionRiskQualifiersUiFields } from 'ui/utilities/commercial/payrollprotection/practitionerAge';
import { buildCoveredPractitionerElement } from '../helper';

export const onQuoteIndicationSchemaChange =
  ({
    payload: {
      model: changedModel,
      key: key,
      //   schema: [],
    },
  }) =>
  (dispatch, _getState) => {
    // Handle specific field changes with switch case
    switch (key) {
      case payrollProtectionKeys.PRACTICE_TYPE:
        handlePracticeTypeChange(changedModel);
        break;

      case payrollProtectionKeys.NO_OF_PRACTITIONERS:
        changedModel = buildCoveredPractitionerElement(changedModel);
        break;

      case payrollProtectionKeys.IDENTIFIER_TYPE:
        changedModel.Risks.PayrollProtectionUnit[0].PractitionerRiskAttributes.NPINumber = '';
        break;

      case payrollProtectionKeys.FIRST_NAME:
      case payrollProtectionKeys.MIDDLE_NAME:
      case payrollProtectionKeys.LAST_NAME:
      case payrollProtectionKeys.SUFFIX:
        handleNameChange(changedModel, key);
        break;

      // Address fields for practice location
      case payrollProtectionKeys.ADDRESS_LINE1:
      case payrollProtectionKeys.ADDRESS_LINE2:
      case payrollProtectionKeys.CITY:
      case payrollProtectionKeys.STATE:
      case payrollProtectionKeys.ZIP:
      case payrollProtectionKeys.COUNTRY:
      case payrollProtectionKeys.LOCATIONS:
        changedModel.Risks.PayrollProtectionUnit[0].PracticeLocationAddresses.IsManual = true;
        // changedModel?.Risks?.Properties?.[0]?.Address?.UnFormattedAddress
        break;

      case payrollProtectionKeys.IS_MANUAL_ADDRESS:
        changedModel.Risks.PayrollProtectionUnit[0].PracticeLocationAddresses.IsManual =
          !!changedModel.Risks.PayrollProtectionUnit[0].PracticeLocationAddresses.IsManual;
        changedModel.Risks.PayrollProtectionUnit[0].PracticeLocationAddresses.AddressLine1 = '';
        changedModel.Risks.PayrollProtectionUnit[0].PracticeLocationAddresses.AddressLine2 = '';
        changedModel.Risks.PayrollProtectionUnit[0].PracticeLocationAddresses.City = '';
        changedModel.Risks.PayrollProtectionUnit[0].PracticeLocationAddresses.State = '';
        changedModel.Risks.PayrollProtectionUnit[0].PracticeLocationAddresses.Zip = '';
        changedModel.Risks.PayrollProtectionUnit[0].PracticeLocationAddresses.Country = '';
        break;

      case payrollProtectionKeys.DATE_OF_BIRTH:
        {
          const dateOfBirth = changedModel.InsuredAccount.OtherDetails.DateOfBirth;
          if (dateOfBirth.length > 0) {
            // Calculate age based on full date of birth, not just year
            const birthDate = moment(dateOfBirth);
            const currentDate = moment();
            let age = currentDate.diff(birthDate, 'years');

            // If birthday hasn't occurred this year, subtract 1
            if (
              currentDate.month() < birthDate.month() ||
              (currentDate.month() === birthDate.month() && currentDate.date() < birthDate.date())
            ) {
              age--;
            }

            changedModel.Risks.PayrollProtectionUnit[0].PractitionerRiskAttributes.Age = age.toString();
          }
        }
        break;

      default:
        // Default behavior - just update the store
        // eslint-disable-next-line no-case-declarations
        const practiceLocationAddress = changedModel.Risks?.PayrollProtectionUnit[0]?.PracticeLocationAddresses || {};
        if (practiceLocationAddress?.Postalcode) {
          practiceLocationAddress.Zip = practiceLocationAddress.Postalcode;
          delete practiceLocationAddress.Postalcode;
        }

        //Underwriter Address Number
        if (changedModel.UnderWriter.Address.Number?.length > 0) {
          changedModel.UnderWriter.Address.Number = Number(changedModel.UnderWriter.Address.Number);
        } else {
          changedModel.UnderWriter.Address.Number = 0;
        }
        break;
    }

    if (key) {
      dispatch({ type: PUT_POLICY, payload: changedModel });
    }
  };

// Handle practice type change - clear related fields based on selection
const handlePracticeTypeChange = (model) => {
  const practiceType = model?.Risks?.PayrollProtectionUnit?.[0]?.PractitionerRiskAttributes?.PracticeType;

  if (practiceType) {
    // Clear NPI Number if Veterinarian is selected
    if (practiceType === practiceTypes.VETERINARIAN) {
      if (model.Risks?.PayrollProtectionUnit?.[0]?.PractitionerRiskAttributes) {
        model.Risks.PayrollProtectionUnit[0].PractitionerRiskAttributes.NPINumber = '';
        model.Risks.PayrollProtectionUnit[0].PractitionerRiskAttributes.IdentifierType = '';
      }
    }

    // Clear Veterinarian ID if Physician, Dentist, or Chiropractor is selected
    if (
      practiceType === practiceTypes.PHYSICIAN ||
      practiceType === practiceTypes.DENTIST ||
      practiceType === practiceTypes.CHIROPRACTOR
    ) {
      if (model.Risks?.PayrollProtectionUnit?.[0]?.PractitionerRiskAttributes) {
        model.Risks.PayrollProtectionUnit[0].PractitionerRiskAttributes.VetID = '';
        model.Risks.PayrollProtectionUnit[0].PractitionerRiskAttributes.IdentifierType = '';
        model.Risks.PayrollProtectionUnit[0].PractitionerRiskAttributes.VetState = '';
        model.Risks.PayrollProtectionUnit[0].PractitionerRiskAttributes.NPINumber = '';
      }
    }
  }
};

// Handle name changes - update display name
const handleNameChange = (model, _changedKey) => {
  const firstName = model?.InsuredAccount?.FirstName || '';
  const middleName = model?.InsuredAccount?.MiddleName || '';
  const lastName = model?.InsuredAccount?.LastName || '';
  const suffix = model?.InsuredAccount?.Suffix || '';

  // Create display name by combining first, middle, and last names
  let displayName = '';
  if (firstName) {
    displayName += firstName;
  }
  if (middleName) {
    displayName += (displayName ? ' ' : '') + middleName;
  }
  if (lastName) {
    displayName += (displayName ? ' ' : '') + lastName;
  }
  if (suffix) {
    displayName += (displayName ? ' ' : '') + suffix;
  }
  // Update the display name in the model
  if (model.InsuredAccount) {
    model.InsuredAccount.DisplayName = displayName;
  }
};

export const onQuoteIndicationFormSubmit =
  ({ payload: { model: payload, setState }, saveAndExit }) =>
  async (dispatch, _getState) => {
    const model = structuredClone(payload);
    const IdentifierType = model.Risks.PayrollProtectionUnit[0].PractitionerRiskAttributes.IdentifierType;
    if (
      IdentifierType === 'NPI' &&
      model.Risks.PayrollProtectionUnit[0].PractitionerRiskAttributes.NPINumber.length !== 10
    ) {
      return toast.error('Please enter 10 digit National Provider Identifier (NPI) number');
    }
    NProgress.start();
    let resp;
    resp = await handleSubmitQuoteLanding(model);
    resp.Agent.Code = payload.Agent.Code;
    NProgress.start();

    if (!saveAndExit) {
      setState({
        showCoveragePlanModal: false,
      });
    }

    dispatch({ type: PUT_POLICY, payload: resp });

    try {
      stripPayrollProtectionRiskQualifiersUiFields(resp);
      resp = await save(resp, commonKeys.EmptyString, routeKeys.QuoteIndication, commonKeys.EmptyString);

      if (!saveAndExit) {
        setState({
          showCoveragePlanModal: true,
        });
      }

      dispatch({ type: PUT_POLICY, payload: resp });
      NProgress.done();
      return resp;
    } catch (error) {
      toast.error(error.message);
      NProgress.done();
      throw new Error(error);
    }
  };
